import React, { useEffect } from "react";
import Styles from "./prediction.module.css";
import { Button, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
    addQuestion,
    modalToggle,
    setEditQuestion,
} from "../../slices/predictionSlice";
import PredictionQuestion from "../../components/PredictionQuestion";
import axios from "axios";
import { apiBaseUrl } from "../../configs/configs";
import { getChildQuestions, getQuestions } from "../../slices/apiCalling";
import moment from "moment";
import Swal from "sweetalert2";


function PredictionChildView(props) {
    const { match_id, series_id, prediction_id } = props.match.params;
    const predictionState = useSelector((state) => state.prediction);
    const dispatch = useDispatch();

    const showModal = (flag = { isSubjective: false }) => {
        dispatch(modalToggle(flag));
    };

    const editQuestion = async (data, flag) => {
        dispatch(modalToggle({ isSubjective: flag}));
        const predictData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("hh:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("hh:mm")}`,
        };
        dispatch(setEditQuestion(predictData));
    };

    const changeStatus = async (id, status) => {
        const result = await axios.post(
            `${apiBaseUrl}/prediction/match/${match_id}/series/${series_id}`,
            { _id: id, status: 1 - status }
        );
        if (result.data.status === "success") {
            getQuestions(match_id, series_id, dispatch, addQuestion);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Status successfully changed",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    };

    const changeStatusForAll = async (status) => {
        const result = await axios.post(
            `${apiBaseUrl}/change_prediction_status/match/${match_id}/series/${series_id}/status/${status}`
        );
        if (result.data.status === "success") {
            getQuestions(match_id, series_id, dispatch, addQuestion);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Status successfully changed",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    };

    const setWinning = async (data) => {
        const result = await axios.post(
            `${apiBaseUrl}/prediction_winning_set`,
            data
        );
        if (result.data.status === "success") {
            getQuestions(match_id, series_id, dispatch, addQuestion);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Winning set successfully",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    };

    const cancelPrediction = async (id) => {
        const result = await axios.post(
            `${apiBaseUrl}/cancel_prediction/prediction/${id}`
        );
        console.log(">>>", result);
    };

    const winningDistribution = async (id) => {
        const result = await axios.post(
            `${apiBaseUrl}/winning_distribution/prediction/${id}`
        );
    };

    useEffect(() => {
        getChildQuestions(prediction_id, dispatch, addQuestion);
    }, []);

    return (
        <div>
            <PredictionQuestion
                match_id={match_id}
                series_id={series_id}
                isSubjective={predictionState.isSubjective}
            />
            <hr></hr>
            <Table responsive hover>
                <thead>
                    <tr>
                        <th scope="col">S No</th>
                        <th scope='col'>Prediction Id</th>
                        <th scope="col">Question</th>
                        <th scope="col">Slots</th>
                    </tr>
                </thead>
                <tbody>
                    {predictionState.question.map((data, i) => {
                        return (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{data._id}</td>
                                <td>{data.question_english}</td>
                                <td>{data.slots}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}


export default PredictionChildView;